"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash.get"));
var _NavWidget = require("./NavWidget.style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var NavWidget = /*#__PURE__*/function (_React$Component) {
  _inherits(NavWidget, _React$Component);
  var _super = _createSuper(NavWidget);
  function NavWidget() {
    var _temp, _this;
    _classCallCheck(this, NavWidget);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.state = {
      currentSelection: (0, _lodash.default)(_assertThisInitialized(_this), 'props.defaultOption'),
      firstOption: (0, _lodash.default)(_assertThisInitialized(_this), 'props.defaultOption.firstOption[0].value'),
      secondOption: (0, _lodash.default)(_assertThisInitialized(_this), 'props.defaultOption.secondOption[0].value')
    }, _this.handleAudienceChange = function (e) {
      var updatedSelection = _this.props.data.find(function (obj) {
        return obj.audience.value === e.target.value;
      });
      _this.setState({
        currentSelection: updatedSelection,
        firstOption: (0, _lodash.default)(updatedSelection, 'firstOption[0].value'),
        secondOption: (0, _lodash.default)(updatedSelection, 'secondOption[0].value')
      });
    }, _this.handleFirstOptionChange = function (e) {
      _this.setState({
        firstOption: e.target.value
      });
    }, _this.handleSecondOptionChange = function (e) {
      _this.setState({
        secondOption: e.target.value
      });
    }, _temp));
  }
  _createClass(NavWidget, [{
    key: "render",
    value: function render() {
      var _this$state = this.state,
        firstOption = _this$state.firstOption,
        secondOption = _this$state.secondOption,
        currentSelection = _this$state.currentSelection;
      var _this$props = this.props,
        data = _this$props.data,
        children = _this$props.children;
      var audience = data.map(function (item) {
        return {
          label: (0, _lodash.default)(item, 'audience.label'),
          value: (0, _lodash.default)(item, 'audience.value')
        };
      });
      var hasMultipleAudienceOptions = audience.length > 1;
      var hasFirstOptions = currentSelection.firstOption && currentSelection.firstOption.length > 0;
      var hasSecondOptions = currentSelection.secondOption && currentSelection.secondOption.length > 0;
      return /*#__PURE__*/_react.default.createElement(_NavWidget.NavWidgetStyled, {
        "data-key": "max-nav-widget"
      }, hasMultipleAudienceOptions && /*#__PURE__*/_react.default.createElement(_NavWidget.LeftColumn, null, /*#__PURE__*/_react.default.createElement(_NavWidget.AudienceText, {
        "data-key": "max-nav-widget__text"
      }, currentSelection.identifierText), /*#__PURE__*/_react.default.createElement(_NavWidget.HiddenLabel, {
        htmlFor: "audience"
      }, "Audience"), /*#__PURE__*/_react.default.createElement(_NavWidget.SelectAudience, {
        id: 'audience',
        name: 'topic',
        options: audience,
        onChange: this.handleAudienceChange,
        defaultValue: (0, _lodash.default)(currentSelection, 'audience.value', ''),
        "data-key": "max-nav-widget__select"
      })), /*#__PURE__*/_react.default.createElement(_NavWidget.RightColumn, null, currentSelection.intentText && /*#__PURE__*/_react.default.createElement(_NavWidget.TopicText, {
        "data-key": "max-nav-widget__select"
      }, currentSelection.intentText), hasFirstOptions && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_NavWidget.HiddenLabel, {
        htmlFor: "firstoption"
      }, "Topic"), /*#__PURE__*/_react.default.createElement(_NavWidget.StyledSelectTopic, {
        id: 'firstoption',
        name: 'option',
        options: currentSelection.firstOption,
        value: firstOption,
        onChange: this.handleFirstOptionChange,
        "data-key": "max-nav-widget__select"
      })), hasSecondOptions && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_NavWidget.HiddenLabel, {
        htmlFor: "secondoption"
      }, "Topic"), /*#__PURE__*/_react.default.createElement(_NavWidget.StyledSelectTopic, {
        id: 'secondoption',
        name: 'option',
        value: secondOption,
        options: currentSelection.secondOption,
        onChange: this.handleSecondOptionChange,
        "data-key": "max-nav-widget__select"
      })), _react.default.Children.map(children, function (child) {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          audience: (0, _lodash.default)(currentSelection, 'audience.value'),
          firstOption: firstOption,
          secondOption: secondOption
        });
      })));
    }
  }]);
  return NavWidget;
}(_react.default.Component);
var _default = NavWidget;
exports.default = _default;